import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router';
import { AuthConfig } from 'softcat:config/auth.ts';
import { useAuth as useLegacyAuth } from 'softcat:hooks/use-auth.ts';
import { SoftcatApiUtils } from 'softcat:utils/softcat-api.ts';

export const AuthCallback = () => {
    const oidcAuth = useAuth();
    const navigate = useNavigate();
    const { refreshUser } = useLegacyAuth();

    useEffect(() => {
        const handleCallback = async () => {
            if (oidcAuth.isLoading) return;

            if (oidcAuth.isAuthenticated && oidcAuth.user?.access_token) {
                SoftcatApiUtils.setTokenProvider(
                    /* v8 ignore start */ () => {
                        return oidcAuth.user?.access_token;
                    } /* v8 ignore stop */,
                );

                try {
                    await refreshUser();
                    navigate('/apps', { replace: true });
                } catch (error) {
                    const isUploaderRole = (error as Error).message === AuthConfig.AuthErrors.UPLOADER_ROLE;
                    const isInsufficientPermissions = (error as Error).message === AuthConfig.AuthErrors.INSUFFICIENT_PERMISSIONS;

                    await oidcAuth.removeUser();
                    SoftcatApiUtils.resetTokenProvider();

                    if (isUploaderRole) {
                        navigate('/login', { replace: true, state: { ssoError: AuthConfig.AuthErrors.UPLOADER_ROLE } });
                    } else if (isInsufficientPermissions) {
                        navigate('/login', { replace: true, state: { ssoError: AuthConfig.AuthErrors.INSUFFICIENT_PERMISSIONS } });
                    } else {
                        navigate('/login', { replace: true });
                    }
                }
                return;
            }

            if (oidcAuth.error) {
                navigate('/login', { replace: true });
            }
        };

        handleCallback();
    }, [navigate, oidcAuth, oidcAuth.error, oidcAuth.isAuthenticated, oidcAuth.isLoading, oidcAuth.user, refreshUser]);

    return (
        <div className="flex min-h-screen flex-1 flex-col items-center justify-center">
            <p className="text-gray-500">
                <FormattedMessage id="AUTH_CALLBACK_SIGNING_IN" />
            </p>
        </div>
    );
};
